import { Injectable } from '@angular/core';
import { DataService } from 'app/shared/services/data.service';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IResult } from 'app/shared/models/result.model';

@Injectable()
export class DiscountService {
    private requestUrl = '';
    constructor(private service: DataService, private configurationService: ConfigurationService) {
        if (this.configurationService.isReady) {
            this.requestUrl = this.configurationService.serverSettings.requestUrl;
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.requestUrl = this.configurationService.serverSettings.requestUrl;
            });
        }
    }
    public getDetailsDescriptionDiscounts(employeeNum: string, employeeCompanyId: string): Observable<IResult> {
        const url =`${this.requestUrl}api/Discounts/getDetailsDescriptionDiscounts?employeeNum=${employeeNum}&employeeCompanyId=${employeeCompanyId}`;
          return this.service.get(url)
              .pipe(
                  map((res: any) => {
                      return res;
                  })
              );
      }
}
